import routerOptions0 from "/usr/src/app/node_modules/.pnpm/nuxt@4.6.1_0d31bd742dd23b7f01dfc87312377fd0/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto",
  sensitive: false
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}